const PAYMENT_CONTEXT_SESSION_KEY = 'paymentContext:lastPayment';

export interface PaymentContextSessionDetails {
  paymentSource?: string;
  amount: number;
  orderId: string;
  txnId?: string;
  razorpayKeyId?: string;
  razorpayCustomerId?: string;
  expiresAt?: number;
}

export interface PaymentContextSession {
  txnId: string;
  paymentSource: string;
  paymentContextQuery: string;
  retryPath: string;
  expiresAt?: number;
  amount?: number;
  razorpayKeyId?: string;
  razorpayCustomerId?: string;
  startedAt: number;
}

const getPaymentSourceFromQuery = (queryString: string): string => {
  const params = new URLSearchParams(queryString);
  return params.get('paymentSource') || 'PAY_VIA_LINK';
};

export const createPaymentContextSession = ({
  details,
  paymentContextQuery,
  retryPath,
}: {
  details: PaymentContextSessionDetails;
  paymentContextQuery: string;
  retryPath: string;
}): PaymentContextSession => {
  return {
    txnId: details.txnId || details.orderId,
    paymentSource: details.paymentSource || getPaymentSourceFromQuery(paymentContextQuery),
    paymentContextQuery,
    retryPath,
    expiresAt: details.expiresAt,
    amount: details.amount,
    razorpayKeyId: details.razorpayKeyId,
    razorpayCustomerId: details.razorpayCustomerId,
    startedAt: Date.now(),
  };
};

export const savePaymentContextSession = (session: PaymentContextSession): void => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(PAYMENT_CONTEXT_SESSION_KEY, JSON.stringify(session));
};

export const readPaymentContextSession = (): PaymentContextSession | null => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.sessionStorage.getItem(PAYMENT_CONTEXT_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PaymentContextSession;
    return parsed?.txnId ? parsed : null;
  } catch {
    return null;
  }
};

export const clearPaymentContextSession = (): void => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(PAYMENT_CONTEXT_SESSION_KEY);
};
